import { Plus } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuButton } from 'core/elements';
import { useAgGridClientTableContext, useNotificationContext } from 'core/states';
import { QuotePartUpsertLine } from 'quotes/components';
import { QuoteType } from 'quotes/enums';
import { IBaseQuote } from 'quotes/types';
import { Color, Variant } from 'theme/enums';

interface IProps {
  buttonLabel?: string;
  quote: IBaseQuote;
  quoteType?: QuoteType;
  onSubmitSuccess?: () => void;
}

export const AddLineButton = ({
  buttonLabel,
  quote,
  quoteType = QuoteType.CUSTOMER,
  onSubmitSuccess,
}: IProps) => {
  const [isAddLineDrawerOpen, setIsAddLineDrawerOpen] = useState(false);

  const { t } = useTranslation();

  const { isLoadingTopNotificationDisplayed } = useNotificationContext();
  const { isDataLoadCompleted } = useAgGridClientTableContext();

  return (
    <>
      <MenuButton
        label={buttonLabel || t('buttonLabelAdd')}
        color={Color.SUCCESS}
        variant={isDataLoadCompleted ? Variant.SOLID : Variant.SOFT}
        startDecorator={<Plus />}
        menuItems={[
          {
            label: t('labelAddLine'),
            onClick: () => setIsAddLineDrawerOpen(true),
          },
        ]}
        disabled={!isDataLoadCompleted || isLoadingTopNotificationDisplayed}
      />

      <QuotePartUpsertLine
        isOpen={isAddLineDrawerOpen}
        onClose={() => setIsAddLineDrawerOpen(false)}
        quote={quote}
        quoteType={quoteType}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
